require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./calculators-how-much-can-i-save-with-my-401-k.json") })
        }
      }, "path---calculators-how-much-can-i-save-with-my-401-k");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---calculators-how-much-can-i-save-with-my-401-k!./.cache/json/calculators-how-much-can-i-save-with-my-401-k.json
// module id = 1963
// module chunks = 231608221292675